module.exports = __webpack_public_path__ + "img/more.99e9fe22.svg";